module.exports = __webpack_public_path__ + "static/media/md-tablet-portrait.10fa9fdb.svg";